import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { HSTTicketModule } from '../UAR/HSTTicketModule';
import { CPSITicketModule } from '../UAR/CPSITicketModule';
import { TicketFormData } from '../types';
import {
  SelectedTicketTypes,
  TicketTitleField,
  TicketDescriptionField,
  TicketDueDateField
} from '../components/ticketDetails';

interface TicketDetailsStepProps {
  form: UseFormReturn<TicketFormData>;
  selectedModule: string;
}

export const TicketDetailsStep: React.FC<TicketDetailsStepProps> = ({ 
  form, 
  selectedModule 
}) => {
  const { setValue, watch, formState: { errors }, control } = form;
  
  // Get the selected ticket types from the previous step
  const selectedTicketTypes = watch('ticketTypes') || [];

  // Set a default title based on module and ticket type if needed
  useEffect(() => {
    const currentTitle = watch('title');
    if (!currentTitle && selectedTicketTypes.length > 0) {
      // Only set default title if it's not already set
      setValue('title', `${selectedModule} - ${selectedTicketTypes.join(', ')}`);
    }
  }, [selectedModule, selectedTicketTypes, setValue, watch]);

  return (
    <Stack spacing={3} sx={{ width: '100%', mt: 1 }}>
      {/* Display selected ticket types */}
      <SelectedTicketTypes selectedTicketTypes={selectedTicketTypes} />
{/*       
      <TicketTitleField 
        control={control} 
        errors={errors} 
        selectedModule={selectedModule} 
      />

      <TicketDescriptionField 
        control={control} 
        selectedTicketTypes={selectedTicketTypes} 
      />
*/}
      {/* UAR specific fields */}
        {selectedModule === 'UAR' && (
          <>
          {/* HST specific fields */}            
            {selectedTicketTypes.includes('HST') && (
              <div>
                <HSTTicketModule updateUARFields={(fields) => setValue("UARFields", fields)} />
              </div>
            )}
            {/* CPSI specific fields */}
            {selectedTicketTypes.includes('CPSI') && (
              <div>
                <CPSITicketModule updateCPSIFields={(fields) => setValue("CPSIFields", fields)} />
              </div>
            )}
          </>
        )}
        
        {/* Due date field */}
      <TicketDueDateField control={control} errors={errors} />
    </Stack>
  );
};